/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/10/22, 2:42 PM
 *
 */

import { MemberTableRow } from 'features/members/components/table/MemberTableRow/MemberTableRow';

export default MemberTableRow;
